"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiseToPower = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Resources_1 = require("../../Resources");
const SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
class RiseToPower extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.RISE_TO_POWER,
            metadata: {
                cardNumber: 'P60',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(3));
                    b.delegates(3).asterix();
                }),
                description: 'Increase your M€ production 3 steps and place 3 delegates. YOU MAY PLACE THEM IN SEPARATE PARTIES.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 3);
        for (let i = 0; i < 3; i++) {
            player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send delegate', { source: 'reserve' }));
        }
        return undefined;
    }
}
exports.RiseToPower = RiseToPower;
//# sourceMappingURL=RiseToPower.js.map